// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__X2Ztd","search":"Header_search__3myN8"};